export default __webpack_public_path__ + "static/media/slide_03.670d80d9.png";